import { GENERIC_SALE_PROCESS_GETTER } from "./constants";
import { GenericSaleProcessState } from "./genericSaleProcess";

const get = (state: GenericSaleProcessState) => {
	return state;
};

export default {
	[GENERIC_SALE_PROCESS_GETTER]: get
};
